// extracted by mini-css-extract-plugin
export var fileUpload = "_ga-1";
export var modalButton = "_ga-0";